export default __webpack_public_path__ + "static/Scroll-Image---Concrete-Foundation-Removal-9150e3f316a87cd67c18e0f2cdf94d92.jpg";